import createAction from '../../common/services/create-action';

export const SET_POST_TYPE_FILTER = 'SET_POST_TYPE_FILTER';
export const setPostTypeFilter = createAction(SET_POST_TYPE_FILTER);
